// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

export const BASE_URL = "http://51.143.216.223:1002";
export const BANK_TRANSFER = 2;
export const PAYPAL = 3;
export const VOUCHER = 4;
export const CHARITY = 5;
export const VOUCHER_INCREASE = 1.1;
